import './Confirm.scss';

const Confirm = ({
    t,
    error,
    isLoading,
    handleConfirm,
    handleCancel,
    currentLang
}) => {
    const getErrorMessage = (error) => {
        if (!error) return null;

        const errorMapping = {
            'Invalid link': 'invalidLink',
            'Token expired or invalid': 'tokenExpired',
            'Failed to verify token': 'verifyFailed',
            'Network error. Please try again.': 'networkError',
            'Failed to unsubscribe': 'unsubscribeFailed',
            'already_unsubscribed': 'alreadyUnsubscribed'
        };

        const errorKey = errorMapping[error];

        if (errorKey && t.errors && t.errors[errorKey]) {
            return t.errors[errorKey];
        }

        return t.error || error;
    };

    if (error) {
        return (
            <div className="unsubscribe__error__container">
                <div className="unsubscribe__error__message">
                    {getErrorMessage(error)}
                </div>
                <button
                    className="unsubscribe__button__confirm"
                    onClick={() => window.location.href = `/${currentLang}`}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    {t.goHome || 'На головну'}
                </button>
            </div>
        );
    }

    return (
        <>
            <h2 className="unsubscribe__title">{t.title}</h2>
            <p className="unsubscribe__subtitle">{t.subtitle}</p>

            <div className="unsubscribe__buttons">
                <button
                    className="unsubscribe__button unsubscribe__button--confirm"
                    onClick={handleConfirm}
                    disabled={isLoading}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    {isLoading ? t.loading : t.buttonConfirm}
                </button>

                <button
                    className="unsubscribe__button unsubscribe__button--cancel"
                    onClick={handleCancel}
                    disabled={isLoading}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    {t.buttonCancel}
                </button>
            </div>
        </>
    );
};

export default Confirm;